export default __webpack_public_path__ + "static/media/account-card-verify.2b046558.svg";